import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { SeguimientoUserService } from '../../services/orden-proceso-services/seguimiento-user.service';
import { MantenedorParametrosRaspberryService } from '../../services/orden-proceso-services/mantenedor-parametros-raspberry.service';
import { MantenedorIoIndustriasPlcService } from '../../services/orden-proceso-services/mantenedor-io-industrias.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { PlantaService } from '../../services/general-services/planta.service';
import { LineaService } from '../../services/general-services/linea.service';
import { MantenedorProductoSpecsService } from '../../services/orden-proceso-services/mantenedor-producto-specs.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { MantenedorProductoLogsService } from '../../services/orden-proceso-services/mantenedor-producto-logs.service';

@Component({
  selector: 'app-mantenedor-producto-logs-perform',
  templateUrl: './mantenedor-producto-logs.component.html',
  styleUrls: ['./mantenedor-producto-logs.component.css']
})
export class MantenedorProductoLogsComponent implements OnInit {

  titulo: string = "Solicitar ordenes de proceso";

  formulario: FormGroup;
  formularioCustom: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  selectedRow: any;

  cmbPlanta: any[] = [];
  cmbLinea: any[] = [];

  memoryList: any[] = [];

  columnDefsModal: any[];
  rowDataModal: any[] = [];
  frameworkComponentsModal: any;
  gridApiModal: any;
  gridColumnApiModal: any;
  rowSelectionModal: any;

  textBoton: string;
  textoBuscar: string;
  textoBuscarModal: string;
  mostrarFormulario = false;
  mostrarFormularioRasp = false;
  deshabilitarLineaRasp:boolean = true;

  tvcModulo: any;
  editableForm = false;

  loading: boolean = false;
  listaVacia: boolean = true;
  listaVaciaModal: boolean = true;
  loadingModal: boolean = false;

  estadoContenedor: boolean = false;
  estadoBd: boolean = false;
  textoContenedor: string = "Solicitando";
  textoBd: string = "Solicitando";
  textoCantidadRasp = "Solicitando";
  textoCantidadNonRasp = "Solicitando";

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  lineaSelected: any;
  cantDias:any;
  idRow=0;

  cmbOpcion: any[] = [
    { clave: 1, valor: 'Activo' },
    { clave: 0, valor: 'Inactivo' }
  ];

  cmbOpcionModal: any[] = [
    { clave: true, valor: 'Activo' },
    { clave: false, valor: 'Inactivo' }
  ];

  check: HTMLInputElement;

  bandchek: boolean = true;
  bandNumLinea: boolean = true;



  @ViewChild('fileInput') fileInput: ElementRef;
  formInputFile: FormGroup;

  DATA = [];
  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _commonForm: CommonFormService,
    private _planta: PlantaService,
    private _linea: LineaService,
    private _indsutriasIo: MantenedorIoIndustriasPlcService,
    private _productoLogs: MantenedorProductoLogsService,
    private _productoSpecs: MantenedorProductoSpecsService,
    private _datos_Maestros: DatosMaestrosService,
    private _logServices : SeguimientoUserService,
  ) { }

  //URI: string = 'RASPBERRY- PARAMETRIZACION';
  URI: string = 'PRODUCTOS ENVIOS DE PERFOR';

  ngOnInit() {
    this._logServices.saveSeguimientoPerform(this.URI); //Ticket 30238 LOG de ingreso en modulos perform

    this.tvcModulo = moduloPerform;
    this.DAT_BTNS = this.tvcModulo.button.buttonsNombre;
    this.DAT_MSG = this.tvcModulo.mensajes;
    this.DAT_BTNCSS = this.tvcModulo.button.buttonsCss;

    this.formularioCustom = this.fb.group({
      idMaterial: ['', [Validators.minLength(6),Validators.maxLength(10)]],
      descMaterial:['', [Validators.required]],
      pesoMax: ['', [Validators.required]],
      pesoMin: ['', [Validators.required]],
      peso: [''],
      pesoEmbalaje: [''],
      alturaCaja:[''],
      retardoRechazo: [''],
      confNsensor: [''],
      confHab:[''],
      usuarioRegister: [''],
      fechaOrden:[''],
      fechaCaduca:[''],
      ean14:['', [Validators.minLength(14),Validators.maxLength(14)]],
      ean128:['', [Validators.minLength(36),Validators.maxLength(36)]],
      lote:['', [Validators.minLength(10),Validators.maxLength(10)]],
      ordenProd:['', [Validators.minLength(12),Validators.maxLength(12)]],
      habCodEan14:[''],
      habCodEan128:[''],
      habMayor:[''],
      habMenor:[''],
      habAlt:['']
    });

    this.formulario= this.fb.group({
      linea:[''],
      planta:[''],
      fechaFabricaIni : [''],
      fechaFabricaFin : ['']
    });


    this.formInputFile = this.fb.group({
      multipart: ['', [Validators.required]]
    });
    this.cargarGrig();
    this.cargarGrigOrdProc();
    //*INVOCACION DE SERVICIOS AL INICIO
    //this.getAll();
    //this.getAllPlanta();
    this.getAllPlantaByUser();
    setTimeout(() => {
      //this.check = document.getElementById("idPropiedad") as HTMLInputElement;
      //this.check.checked = false;
    }, 200);

      this.formularioCustom.get("habCodEan14").disable();
      this.formularioCustom.get("habCodEan128").disable();
      this.formularioCustom.get("habMenor").disable();
      this.formularioCustom.get("habMayor").disable();
      this.formularioCustom.get("habAlt").disable();


    /*const fechaActual = new Date();
    const fechaInicio = new Date(fechaActual.getTime() - 7 * 24 * 60 * 60 * 1000);
    this.formulario.get('fechaFabricaIni').setValue(fechaInicio);
    this.formulario.get('fechaFabricaFin').setValue(fechaActual);*/
    const fechaInicio = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    this.formulario.get('fechaFabricaIni').setValue(this._util.formatStadardFecha(fechaInicio));
    this.formulario.get('fechaFabricaFin').setValue(this._util.getFechaGuion());
    console.log("frmulario->", this.formulario.value);

  }

  /** SERVICIOS */
  getAll() {
    this.loading = true;
    this._productoLogs.getAllOrdenProductos().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;

      this.listaVacia = this.rowData.length > 0 ? false : true;
    }, (err) => {
      this.loading = false;
      this.rowData = this.DATA;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    });
  }



  getAllPlanta() {
    this._planta.getAllbyPerfor().subscribe((res: any) => {
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      this.cmbPlanta = [];
    });
  }

  getAllPlantaByUser() {
    this._planta.getAllbyPerforByUser(localStorage.getItem('userName')).subscribe((res: any) => {
    //this._planta.getAllbyPerforByUser('rtoro').subscribe((res: any) => {
      console.log('load',res.respuesta);
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      console.log('err',err);
      this._util.mensajeErroToast("No se encontro Plantas asignadas a su usuario, por favor contacte al administrador",3000);
      this.cmbPlanta = [];
    });
  }

  /** FUNCIONES */
  nuevo() {
    this.textBoton = this.DAT_BTNS.guardar;
    this.titulo = "Guardar Parametrización Raspberry";
    this._commonForm.abrirFormularioParaGuardar(this);
  }

  /*editar({ rowData }) {
    let id = 0;
    this.cmbPlanta.forEach(element =>{
      if(element.nombre === rowData.nombrePlanta){
        id = element.id;
      }
    });
    this.cmbLinea = [{id:rowData.idLinea,nombre:rowData.nombreLinea}];
    const clonData = {
      active: rowData.active,
      ipRb: rowData.ipRb,
      nombre: rowData.nombre,
      idLinea: rowData.idLinea,
      port: rowData.port,
      idPlanta: id
    }
    this.textBoton = this.DAT_BTNS.editar;
    this.titulo = "Editar Parametrización Raspberry";
    this._commonForm.abrirFormularioParaEditar(this, clonData);
  }*/


  carfas(from,row){
     const obj = from.cmbLinea.find( e => e.id === row.data.idLinea);
     if(obj !== undefined)
      return obj.nombre;
     else
      return '?';
   }


  cargarGrig() {
    this.columnDefs = [
      /*{
        headerName: "Editar",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.procesarSolicitud.bind(this),
          label: "Editar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.warning,
        },
      },*/
      {
        headerName: 'Elemento',
        field: 'id',
        sortable: true,
        filter: true,
        width: 200,
        floatingFilter: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
      },
      {
        headerName: "Eliminar",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: "Eliminar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.alert,
        },
      },{
        headerName: "Editar",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.editarEnvio.bind(this),
          label: "Editar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.alert,
        },
      },{
        headerName: "Estado",
        field: "estado",
        sortable: true,
        filter: true,
        width: 150,
        valueGetter: function (params) {
          switch(params.data.estado){
              case 1:
                return 'Por enviar';
              case 2:
                return 'Enviado';
              case 3:
                return 'Error';
              default:
                return 'Unknow';
          }

        }
      },
      {
        headerName: "Id Material",
        field: "idMaterial",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Desc Material",
        field: "material.descripcionMaterial",
        sortable: true,
        filter: true,
        width: 300,
      },
      {
        headerName: "Fecha cad.",
        field: "fechaCaducidad",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Lote",
        field: "lote",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Orden de proceso",
        field: "ordProc",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Ean128",
        field: "codEan",
        sortable: true,
        filter: true,
        width: 350,
      }

    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = "multiple";
  }

  cargarGrigOrdProc() {
    this.columnDefsModal = [
      {
        headerName: "",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.elaborarEnvio.bind(this),
          label: "Agregar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.info,
        },
      },
      {
        headerName: "Orden Proceso",
        field: "ordenProceso",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Material",
        field: "material",
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: "Lote",
        field: "lote",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Cantidad",
        field: "cantidad",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Descripción",
        field: "desca",
        sortable: true,
        filter: true,
        width: 350,
      },

    ];
    this.frameworkComponentsModal = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelectionModal = "multiple";
  }


  changeRowColor(params) {
    if (params.data.active) {
      return { 'color': 'green', 'font-weight': 'bold' };
    } else {
      return { 'color': 'red', 'font-weight': 'bold' };
    }
  }

  changeRowColorStatus(params) {
    if (params.data.status) {
      return { 'color': 'green', 'font-weight': 'bold' };
    } else {
      return { 'color': 'red', 'font-weight': 'bold' };
    }
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onQuickFilterChangedModal() {
    this.gridApiModal.setQuickFilter(this.textoBuscarModal);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGridReadyModal(params) {
    this.gridApiModal = params.api;
    this.gridColumnApiModal = params.columnApi;
  }

  acciones(event) {
    console.log(event);
    if (event === "guardar") {
        this.guardar();

    }else {
      this.mostrarFormulario = false;
    }
  }



  eliminar({ rowData }) {
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.eliminar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.eliminar,
        funcion: this._productoLogs.deleteRegistro(rowData.id),
      }
    ).then((res: any) => {
      this.rowData = this.rowData.filter((item) => item.idMaterial !== rowData.idMaterial);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  guardar() {
    const clonData = {
      idMaterial: new String(this.formularioCustom.get("idMaterial").value),
      idLinea: this.lineaSelected,
      lote: this.formularioCustom.get("lote").value,
      fechaCaducidad: this.formularioCustom.get("fechaCaduca").value,
      fechaOrden:this.formularioCustom.get("fechaOrden").value,
      ordProc:this.formularioCustom.get("ordenProd").value,
      codEan:this.formularioCustom.get("ean128").value,
      variables:"[]",
      estado:1,
      id:null
      /*perGeneral: this.formularioCustom.get("perGeneral").value,
      perMax: this.formularioCustom.get("perMax").value,
      perMin: this.formularioCustom.get("perMin").value,

      retardoRechazo: this.formularioCustom.get("retardoRechazo").value,
      peso: this.formularioCustom.get("peso").value,
      pesoEmbalaje: this.formularioCustom.get("pesoEmbalaje").value,
      alturaCaja: this.formularioCustom.get("alturaCaja").value,
      confNsensor: this.formularioCustom.get("confNsensor").value,
      confHab: this.formularioCustom.get("confHab").value,*/
    }
    this.loading = true;
    if(this.editableForm){
      clonData.id =this.idRow;
      this._util.confirmarSincronoPromesa(
        {
          title: this.tvcModulo.mensajes.guardar,
          text: ``,
          action: this.tvcModulo.button.buttonsNombre.guardar,
          funcion: this._productoLogs.actualizarProductoSpecs(clonData),
        }
      ).then((res: any) => {
        //this.titulo = "Parametrización Raspberry";
        document.getElementById('cerrarModal').click();
        this.selecionLinea();
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    }else{
      this._util.confirmarSincronoPromesa(
        {
          title: this.tvcModulo.mensajes.guardar,
          text: ``,
          action: this.tvcModulo.button.buttonsNombre.guardar,
          funcion: this._productoLogs.crearProductoSpecs(clonData),
        }
      ).then((res: any) => {
        //this.titulo = "Parametrización Raspberry";
        document.getElementById('cerrarModal').click();
        this.selecionLinea();
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    }
  }

  editar({ rowData }) {
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.guardar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.guardar,
        funcion: this._productoLogs.crearProductoSpecs(this.formulario.value),
      }
    ).then((res: any) => {
      this.titulo = "Parametrización Raspberry";
      this.getAll();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }



  callModalRasp({ rowData }) {
    this.deshabilitarLineaRasp = true;
    //this.plantilla.idLinea = rowData.idLinea;
    //this.lineaSeledted = this.plantilla.ipRb;
    document.getElementById('callModal').click();
    //this.getParamslinea();
  }


  callModal({ rowData }) {
    this.mostrarFormularioRasp = true;
  }

  getLineaPlantaByid(idPlanta) {
    const planta = this.cmbPlanta.find((e) => e.id === idPlanta);
    this._linea.lineasByCodigoPlantaActiva(planta.id).subscribe((res: any[]) => {
      this.cmbLinea = res;
      //this.cargarGridRasp();
    }, (err) => {
      this.cmbLinea = [];
      console.log(err);
    });
  }

  getLineaPlanta() {
    let idPlanta = this.formulario.get('planta').value;
    const planta = this.cmbPlanta.find((e) => e.id === idPlanta);
    console.log(planta);
    this._linea.getByIdbyPerfor(planta.id).subscribe((res: any[]) => {
      this.cmbLinea = res;
      if(this.cmbLinea.length>0){
        this.formulario.get('linea').setValue(this.cmbLinea[0].id);
        this.selecionLinea();
      }
    }, (err) => {
      this.cmbLinea = [];
      console.log(err);
    });
  }



  exportar() {
    const cabecera: any[] = [['DB', 'PROPIEDAD', 'POSICION', 'TDATO', 'LONGITUD', 'ENVIADO', 'STATUS']];
    const data: any[] = this.rowDataModal.map((x) => Object.assign({}, x));
    let body = [];
    data.forEach(e => {
      body.push({ "db": e.db, "propiedad": e.propiedad, "posicion": e.posicion, "tdato": e.tdato, "longitud": e.longitud, "enviado": e.enviado, "status": e.status });
    });
    this._util.exportCSV(cabecera, body, "config.csv");
  }

  clickChosseFile() {
    this.fileInput.nativeElement.value = '';
    this.formInputFile.get('multipart').setValue('');
    document.getElementById('csvInput').click();
  }

  async onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formInputFile.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formInputFile.get('multipart').setValue(file);
        this.importar(file);
      }
    }
  }

  async importar(file: any) {
    this.rowDataModal = [];
    const str = await this._util.readFileContent(file);
    const filas = str.split(/\r\n|\n/);
    const cabecera = filas[0].split(/\t|;/);
    let cuerpo: any[] = [];
    filas.forEach((col, i) => {
      if (i > 0) {
        let columna = filas[i].split(/\t|;/);
        if (columna.length == cabecera.length) {
          cuerpo.push({ "db": columna[0], "propiedad": columna[1], "posicion": columna[2], "tdato": columna[3], "longitud": columna[4], "enviado": columna[5], "status": columna[6] });
        }
      }
    });
    let hash = {};
    cuerpo = cuerpo.filter(o => hash[o.propiedad] ? false : hash[o.propiedad] = true);
    this.rowDataModal = cuerpo;
  }


  procesarSolicitud( { rowData } ){
    this.selectedRow = rowData;
    console.log(rowData);
    rowData.lote;
    rowData.ordenProceso;
    document.getElementById('abrirModal').click();

  }

  procesar(){
    if(this.formulario.get('linea').value === ''){
      this._util.mensajeErroToast('Por favor elija una linea');
      return;
    }
    this.editableForm = false;
    this.mostrarFormulario = true;
    this.loadingModal = true;
    this._indsutriasIo.getAllOrdenProceosNonProcesedLastWeek().subscribe((res: any) => {
      this.loadingModal = false;
      this.rowDataModal = res;
      this.listaVaciaModal = this.rowDataModal.length > 0 ? false : true;
      console.log(res);
    }, (err) => {
      this.loadingModal = false;
      console.log(err);
    });
  }
  editarEnvio({ rowData }){
    console.log(rowData);
    this.editableForm = true;
    this.idRow = rowData.id;
    document.getElementById('abrirModal').click();
    this.formularioCustom.get('idMaterial').setValue(rowData.idMaterial);
    this.formularioCustom.get('descMaterial').setValue(rowData.material.descripcionMaterial);
      this.formularioCustom.get('pesoEmbalaje').setValue(rowData.productoSpecs.pesoEmbalaje);
      this.formularioCustom.get('retardoRechazo').setValue(rowData.productoSpecs.retardoRechazo);
      this.formularioCustom.get('confNsensor').setValue(rowData.productoSpecs.confNsensor);
      this.formularioCustom.get('confHab').setValue(rowData.productoSpecs.confHab);
      this.formularioCustom.get('alturaCaja').setValue(rowData.productoSpecs.alturaCaja);
      this.formularioCustom.get('peso').setValue(rowData.productoSpecs.peso);
      this.formularioCustom.get('pesoMax').setValue(rowData.productoSpecs.peso*(1+(rowData.productoSpecs.perMax/100)));
      this.formularioCustom.get('pesoMin').setValue(rowData.productoSpecs.peso*(1-(rowData.productoSpecs.perMin/100)));
      this.formularioCustom.get('fechaCaduca').setValue(rowData.fechaCaducidad);
      this.formularioCustom.get('fechaOrden').setValue(rowData.fechaOrden);
      this.formularioCustom.get('ordenProd').setValue(rowData.ordProc);
      this.formularioCustom.get('lote').setValue(rowData.lote);
      this.formularioCustom.get("habCodEan14").setValue(rowData.productoSpecs.habCodEan14);
      this.formularioCustom.get("habCodEan128").setValue(rowData.productoSpecs.habCodEan128);
      this.formularioCustom.get("habMenor").setValue(rowData.productoSpecs.habMenor);
      this.formularioCustom.get("habMayor").setValue(rowData.productoSpecs.habMayor);
      this.formularioCustom.get("habAlt").setValue(rowData.productoSpecs.habAlt);
      this.formularioCustom.get('ean14').setValue(rowData.codEan.substring(2,16));
      this.formularioCustom.get('ean128').setValue(rowData.codEan);

  }

  itemSelected: any;
  elaborarEnvio({ rowData }, viewForm: boolean){
    this.formularioCustom.get('idMaterial').setValue(new Number(rowData.material));
    this.formularioCustom.get('descMaterial').setValue(rowData.desca);
    this.lineaSelected = this.formulario.get('linea').value;

    //T.26678, se agrega bandera para validar y reusar el llenado del formulario
    viewForm = viewForm === undefined ? true : viewForm; 
    this.itemSelected = rowData;
    //end 

    this._productoSpecs.buscarProductoLineaSpecs(new Number(rowData.material),this.lineaSelected)
    .subscribe((res: any) => {
      document.getElementById('abrirModal').click();
      let fechaNow = new Date();
      //this.fechaCalculada = new Date(res.fecha);
      //this.fechaCaducidad = this.addDays(this.fechaCalculada,res.material.duracionTotal);
      console.log("duracion en dias del producto",res.material.duracionTotal);
      this.cantDias = res.material.duracionTotal;
      this.formularioCustom.get('descMaterial').setValue(res.material.descripcionMaterial);
      this.formularioCustom.get('pesoEmbalaje').setValue(res.pesoEmbalaje);
      this.formularioCustom.get('retardoRechazo').setValue(res.retardoRechazo);
      this.formularioCustom.get('confNsensor').setValue(res.confNsensor);
      this.formularioCustom.get('confHab').setValue(res.confHab);
      this.formularioCustom.get('alturaCaja').setValue(res.alturaCaja);
      this.formularioCustom.get('peso').setValue(res.peso);
      this.formularioCustom.get('pesoMax').setValue(res.peso*(1+(res.perMax/100)));
      this.formularioCustom.get('pesoMin').setValue(res.peso*(1-(res.perMin/100)));
      this.formularioCustom.get('fechaOrden').setValue(fechaNow.toLocaleString("en-SE", { timeZone: "America/Guayaquil" }).substring(0, 10));
      this.formularioCustom.get('fechaCaduca').setValue(this.addDays(fechaNow,res.material.duracionTotal).toLocaleString("en-SE", { timeZone: "America/Guayaquil" }).substring(0, 10));
      this.formularioCustom.get('ordenProd').setValue(rowData.ordenProceso);
      this.formularioCustom.get('lote').setValue(rowData.lote);
      this.formularioCustom.get("habCodEan14").setValue(res.habCodEan14);
      this.formularioCustom.get("habCodEan128").setValue(res.habCodEan128);
      this.formularioCustom.get("habMenor").setValue(res.habMenor);
      this.formularioCustom.get("habMayor").setValue(res.habMayor);
      this.formularioCustom.get("habAlt").setValue(res.habAlt);
      //console.log(this.fechaCaducidad.toISOString().slice(0,10).replace(/-/g,""));
      //console.log(this.formularioCustom.get('fechaCaduca').value.replace(/-/g,"").slice(2));
        this._productoSpecs.buscarMaterialPresentacion(res.material.idMaterial).subscribe((res2: any) => {
          this.formularioCustom.get('ean14').setValue(res2.codigoEAN);
          this.formularioCustom.get('ean128').setValue('01'+res2.codigoEAN+'17'+(this.addDays(fechaNow,res.material.duracionTotal).toISOString().slice(0,10).replace(/-/g,"")).slice(2)+'10'+rowData.lote);
        }, (err) => {

          console.log(err);
        })

    }, (err) => {
      //this._util.mensajeErrorVisto('El material '+new Number(rowData.material)+' no se ha registrado sus especificaciones, por favor parametrizarlos en [Especificación Producto]',true,10000);
      if(viewForm)
        this.getMaterialAutomatico(Number(rowData.material)); // T.26678 | Adición de registros automáticamente cuando se crea o registra un lote para envió al PERFOR
      
      console.log(err);
    });
  }

  buscar(){
    if(this.formularioCustom.get('idMaterial').value.length > 1){
      this._datos_Maestros.getMaterialxId(this.formularioCustom.get('idMaterial').value).subscribe((res: any) => {
        //this.cargarGridRasp();
        this.formularioCustom.get('descMaterial').setValue(res.dscaMaterial);
        console.log(res);
      }, (err) => {

        console.log(err);
      });
      this._productoSpecs.buscarMaterialPresentacion(this.formularioCustom.get('idMaterial').value).subscribe((res: any) => {
        //this.cargarGridRasp();
        this.formularioCustom.get('peso').setValue(res.pesoBruto*1000);
        this.formularioCustom.get('alturaCaja').setValue(res.altura);
        console.log(res);
      }, (err) => {

        console.log(err);
      });
    }

  }

  limpiarDes(){
    this.formularioCustom.get('descMaterial').setValue("");
  }

  selecionLinea(){
    this.lineaSelected =  this.formulario.get('linea').value;
    this.loading = true;
/*    this._productoLogs.buscarbyIdLinea(this.formulario.get('linea').value).subscribe((res: any) => {
      this.loading = false;
      this.rowData = res;
      console.log("INICIAL DATOS ASIGENEN -> ",res);
      this.listaVacia = this.rowData.length > 0 ? false : true;
    }, (err) => {
      this.loading = false;
      this.rowData = this.DATA;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    });*/

    this._productoLogs.buscarbyIdLineaQuery(this.formulario.value).subscribe((res: any) => {
      this.loading = false;
      this.rowData = res.respuesta;
      this.listaVacia = this.rowData.length > 0 ? false : true;
    }, (err) => {
      this.loading = false;
      this.rowData = this.DATA;
      this.listaVacia = this.rowData.length === 0 ? true : false;
       console.log("Error datd -> ",err);
    });


  }

  truncarDate(fecha){
    if(fecha.length > 9)
      return fecha.substring(0,10).replaceAll("-", "");
    else
      return "";
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  padLeft(text:string, padChar:string, size:number): string {
    return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
  }

  refrescarEan(){
    this.formularioCustom.get('ean128').setValue('01'+this.formularioCustom.get('ean14').value+'17'+(this.formularioCustom.get('fechaCaduca').value.replace(/-/g,"")).slice(2)+'10'+this.padLeft(this.formularioCustom.get('lote').value,'0',10));
  }

  async procesarComplexCabaceras(){

    let strErrores = " con Errores(Revisar Adjunto) ";
    let hasError = 1;
    //this.listadocs = "Procesado";

    if(this.gridApi === undefined){
      this._util.mensajeErroToast("Por favor seleccione una planta y una línea",3000);
      return;
    }

    const selectedRows: any[] = this.gridApi.getSelectedRows();
    if(selectedRows === undefined || selectedRows.length === 0){
      this._util.mensajeErroToast("Por favor seleccione al menos un elemento",3000);
      this.loading = false;
      return;
    }
    this.loading = true;
    console.log(selectedRows);
    this._productoLogs.enviarPlcProductoSpecs(selectedRows)
    .subscribe((res: any) => {
      console.log(res);
      this.loading = false;
      this._util.mensajeOKVisto("CORRECTO", true,1000);
      this.selecionLinea();
    }, (err) => {
      this.loading = false;
      this._util.mensajeErrorVisto(err.error.mensaje,true,10000);
      this.selecionLinea();
      console.log(err);
    });
    /*for (let i = 0; i < selectedRows.length; i++) {
      const e = selectedRows[i];
      console.log(e);
      this._util.alertifyToastOK('Enviando documento: '+e.idPedido);
      await this.petcion(e).then((res: any) => {
        //console.log(res);
        if(res.respuesta.estado === 3){
          hasError = 2;
          strErrores = strErrores+'<br>'+e.idPedido+' con error';//+res.mensaje.split(':')[1];
        }else{
          this.listadocs = this.listadocs +'<br>'+e.idPedido+' '+'ok '+(res.mensaje.split(':')[1]!==undefined ? res.mensaje.split(':')[1] : ' ');//;
        }
      }).catch(err => {
        hasError = 2;
        strErrores = strErrores+'<br>'+e.idPedido+':'+ err.error.mensaje;
        console.log(err);
      });
      this.porcentaje=((i+1)/selectedRows.length)*100;
    }*/

  }

  petcion(element: any) {
    const fecha = element.fechaEntr.toString().substring(0,10);
    let data = {
      paramOrder: element.idPedido+' | '+fecha,
      idCliente: element.idCliente,
      idEmpresa: element.idEmpresa
    }
    /*return new Promise((resolve, reject) => {
      this.detallePedido.procesarDetalleOrdenVenta(data).subscribe((res: any[]) => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });*/
  }

  changeFechaOrden(){
    let dates = this.addDays(new Date(this.formularioCustom.get('fechaOrden').value),1);
    this.formularioCustom.get('fechaOrden').setValue(dates.toLocaleString("en-SE", { timeZone: "America/Guayaquil" }).substring(0, 10));
    this.formularioCustom.get('fechaCaduca').setValue(this.addDays(dates,this.cantDias).toLocaleString("en-SE", { timeZone: "America/Guayaquil" }).substring(0, 10));
    this.formularioCustom.get('ean128').setValue('01'+this.formularioCustom.get('ean14').value+'17'+(this.formularioCustom.get('fechaCaduca').value.replace(/-/g,"")).slice(2)+'10'+this.padLeft(this.formularioCustom.get('lote').value,'0',10));
  }

  changeFechaCaducidad(){
    this.formularioCustom.get('ean128').setValue('01'+this.formularioCustom.get('ean14').value+'17'+(this.formularioCustom.get('fechaCaduca').value.replace(/-/g,"")).slice(2)+'10'+this.padLeft(this.formularioCustom.get('lote').value,'0',10));
  }

  /* T.26678 | Adición de registros automáticamente cuando se crea o registra un lote para envió al PERFOR
  SOLICITUD DE RICHARD */
  getMaterialAutomatico(material){
    let alertas:string = "";
    let mensaje   = 'El material ' + material +' no se ha registrado sus especificaciones, por favor parametrizarlos en [Especificación Producto]';
    let mensaje_1 = 'El material ' + material +' no tiene registrado sus especificaciones. Desea registrar el material en [Especificación Producto]';

    // DEFINE OBJETO POR DEFECTO
    let materialCrear = {
      idMaterial  : material,
      idLinea     : this.lineaSelected,
      perGeneral  : 1.5, 
      perMin      : 1.5,
      perMax      : 1.5,
      pesoEmbalaje: 0, 
      retardoRechazo : 400,
      confNsensor : 2, 
      confHab     : 31,
      peso        : 0,
      alturaCaja  : 0,
      habAlt      : true,
      habMayor    : true,
      habMenor    : true,
      habCodEan128: true,
      habCodEan14 : true
    };

    if(material){
      // BUSCA EN MATERIAL PRESENTACION
      this._productoSpecs.buscarMaterialPresentacion(material).subscribe((res: any) => {
        materialCrear.peso = (res.pesoBruto*1000);
        materialCrear.alturaCaja = res.altura;
        
        if(materialCrear.peso === 0){
          alertas = "Error en intento de crear material sin valor en peso. ";
        }        
        if(materialCrear.alturaCaja === 0) {
          alertas = alertas + "Error en intento de crear material sin valor en altura. ";
        }
  
        if(alertas.length === 0){
          this._util.confirmarSincronoPromesa({
            title : mensaje_1,
            text  : ``,
            action: "Crear Producto "+ material,
            funcion:  this._productoSpecs.crearProductoSpecs(materialCrear),
          }).then((res: any) => {
            this.loading = false;
            this.elaborarEnvio({ rowData: this.itemSelected }, false);

          }, () => {
            this._util.mensajeErrorVisto(mensaje,true,10000);
            console.log("Acción para crear material cancelada");
            this.loading = false;
          });
        }else{
          this._util.mensajeErrorVisto(mensaje + alertas, true, 10000);
          console.error(alertas);
        }

      }, (err) => {
        console.log(err);
        console.error("No existe consulta en DATASAP.MATERIAL_PRESENTACION")
      });
    }
  }
  // END T.26678

}
